"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Icons_1 = require("../../icons/Icons");
var DomWidgets_1 = require("../DomWidgets");
var SharedWidgets_1 = require("../../SharedWidgets");
var style = {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
};
var buttonStyle = {
    height: 30,
    width: 30,
};
var CarouselWidget = /** @class */ (function (_super) {
    tslib_1.__extends(CarouselWidget, _super);
    function CarouselWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CarouselWidget.prototype.getContent = function (icon) {
        return function (state) {
            var imgProps = {
                draggable: false,
                height: icon.height,
                src: Icons_1.encodeSvg(icon.icon(state)),
                width: icon.width,
            };
            return (React.createElement(React.Fragment, null,
                React.createElement(DomWidgets_1.Img, tslib_1.__assign({}, imgProps))));
        };
    };
    CarouselWidget.prototype.render = function () {
        var leftArrowProps = {
            buttonType: SharedWidgets_1.ButtonType.Icon,
            getContent: this.getContent(Icons_1.StepperLeftIcon),
            handleClick: this.props.onPreviousClick,
            style: buttonStyle,
            testId: 'stepper-left',
            title: this.props.prevButtonTitle,
        };
        var rightArrowProps = {
            buttonType: SharedWidgets_1.ButtonType.Icon,
            getContent: this.getContent(Icons_1.StepperRightIcon),
            handleClick: this.props.onNextClick,
            style: buttonStyle,
            testId: 'stepper-right',
            title: this.props.nextButtonTitle,
        };
        return (React.createElement("div", { style: tslib_1.__assign({}, style, this.props.style) },
            React.createElement(SharedWidgets_1.ButtonWidget, tslib_1.__assign({}, leftArrowProps)),
            React.createElement("span", { id: this.props.id, role: this.props.role, "aria-live": 'assertive', "aria-atomic": 'true' }, this.props.children),
            React.createElement(SharedWidgets_1.ButtonWidget, tslib_1.__assign({}, rightArrowProps))));
    };
    return CarouselWidget;
}(React.PureComponent));
exports.CarouselWidget = CarouselWidget;
//# sourceMappingURL=CarouselWidget.js.map